import clsx from 'clsx';
import capitalize from "../../../helpers/capitalize";
import React from 'react';
import { MilestoneStatuses } from "../../../types/Milestones";
import { createStyles } from "./styles";

var MilestoneItem = function MilestoneItem(props) {
  var classes = createStyles(props);

  var label = props.label,_props$status = props.status,status = _props$status === void 0 ? MilestoneStatuses.INACTIVE : _props$status,visualType = props.visualType;
  return /*#__PURE__*/(
    React.createElement("li", {
      className: clsx(
      classes.milestoneWrapper,
      classes["milestoneWrapperVisualType".concat(capitalize(visualType))]) }, /*#__PURE__*/


    React.createElement("span", {
      className: clsx(
      classes.milestoneLabel,
      classes["milestoneLabelVisualType".concat(capitalize(visualType))]) },


    label), /*#__PURE__*/

    React.createElement("div", {
      className: clsx(
      classes.milestoneItem,
      classes["milestoneItemVisualType".concat(capitalize(visualType))],
      classes["milestoneItem".concat(capitalize(status))]) })));




};

export default MilestoneItem;
//# sourceMappingURL=index.js.map